module.exports = __webpack_public_path__ + "img/chestline.9a4ed2bb.png";